//assets
import { ReactComponent as DashboardIcon } from '../assets/images/sidebar/DashboardMainIcon.svg';
import { ReactComponent as SelectedDashboardIcon } from '../assets/images/sidebar/SelectedDashboardMainIcon.svg';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const DashboardMenu = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'item',
    name: 'dashboard',
    url: '/dashboard',
    selected_icon: SelectedDashboardIcon,
    icon: DashboardIcon,
    breadcrumbs: false
};

export default DashboardMenu;
